import React from 'react';
import PropTypes from 'prop-types';
import styles from './button.module.scss';

const handleOnClick = (whenOnClick) => {
  return (e) => {
    whenOnClick();
  };
};

const Button = ({ children, whenOnClick, disabled }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={handleOnClick(whenOnClick)}
      className={styles.button}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  disabled: false,
};

Button.propTypes = {
  whenOnClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/button.js